import {IComponentOptions, ILogService, IRootScopeService, IWindowService} from "angular";
import {User} from "../model/User";
import {FacultyService} from "../faculty/faculty.service";
import {AuthService} from "../auth/auth.service";
import "./navigation.less";

class NavigationController {
    public user: User;
    public navbarCollapsed: boolean = true;
    public userFaculties: any[];

    private logoutUrl: string;
    private dashboardUrl: string;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $window: IWindowService,
                private $rootScope: IRootScopeService,
                private authService: AuthService,
                private facultyService: FacultyService) {
    }

    public $onInit() {
        if (this.user && this.user.faculties) {
            this.facultyService.getFacultyEnumMap().then((facultyEnumMap) => {
                this.userFaculties = this.user.faculties.map((faculty) => {
                    this.$log.debug(faculty);
                    return facultyEnumMap[faculty];
                });
            });
        }

        this.dashboardUrl = this.getDashboardUrl();

        this.$log.info("NavigationController, initialised with user %s", this.user.username);
    }


    public logout() {
        this.authService.logout()
            .then((data: any) => {
                this.$log.debug("logout response", data);
                this.user = undefined;
                this.$window.location.href = this.logoutUrl;
            });
    }

    private getDashboardUrl() {
        if (this.isStudentDashboardOnlyAllowed()) {
            return this.studentDashboardUrl();
        }
        return  this.staffDashboardUrl();
    }

    private isStudentDashboardOnlyAllowed() {
       return !this.isOnlineCreditStaff();
    }

    private isOnlineCreditStaff() {
        return this.user.isCentralAdmissions || this.user.isFacultyAdmin();
    }

    private studentDashboardUrl() {
        return this.$window.location.protocol + "//" + this.$window.location.host + "/student/dashboard";
    }

    private staffDashboardUrl() {
        return this.$window.location.protocol + "//" + this.$window.location.host ;
    }
}

export const NavigationComponent: IComponentOptions = {
    bindings: {
        showLogout: "@",
        user: "<",
        logoutUrl: "<"
    },
    controller: NavigationController,
    template: require("./navigation.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/navigation/navigation.component.ts